<template>
    <v-card class="mb-5">
        <!-- <odeme v-model="Rez"> </odeme> -->
        <tahsilatdialog ref="tahsilatdialog" v-model="tahsilatlar" @updateData="handleUpdateOdemeData"></tahsilatdialog>

        <v-flex xs12 sm12 md12>

            <v-flex xs12 sm12 md12>
                <span class=" font-weight-regular grey--text title">
                    Tahsilat Bilgileri
                </span>
                <v-divider></v-divider>
            </v-flex>
            <caricomp v-bind:autofocuss="true" :Coper="true" :v-bind:statecariyedek="statecari" @sendCurrentInfo="getCurrentInfo($event)" v-bind:zorunlumu="true" v-model="carikod.kod">
            </caricomp>
            <v-card flat>
                <v-card flat>
                    <v-flex xs12 pt-4 sm12 md12>
                        <v-btn fab small color="info" bottom right absolute @click="OdemeEkle()">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-flex>
                </v-card>
                <v-data-table :headers="headerstahsilat" :items="tahsilatlar">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                    <template slot="items" slot-scope="props">
                        <td class="text-xs-left">
                            {{ props.item.EvrakNo }}</td>
                        <td class="text-xs-left">
                            {{ props.item.evrakTipi }}</td>
                        <td class="text-xs-center">
                            {{ props.item.OdemeTarihi }}
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.ParaBirimi }}
                        </td>
                        <td class="text-xs-right">
                            {{ props.item.Tutar }}
                        </td>
                        <td class="text-xs-right">
                            {{ props.item.Kur }}
                        </td>
                        <td class="text-xs-right">

                            <v-btn icon class="mx-0" @click="OdemeSil(props.item)">
                                <v-icon color="pink">delete
                                </v-icon>
                            </v-btn>
                            <!-- <v-btn icon class="mx-0" @click="OdemeDuzenle(props.item)">
                                              <v-icon color="teal">edit</v-icon>
                                            </v-btn> -->
                        </td>

                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        {{ "Kayıt Bulunamadı" }}

                    </v-alert>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-card>
</template>

<script>
import tahsilatdialog from "../tahsilatdialog.vue"
import caricomp from '@/components/app/customcomp/caricomp.vue'
export default {
    data() {
        return {
            statecari:[],
            headerstahsilat: [{
                text: 'Evrak No',
                value: "evrakNo",
                sortable: false
            },
            {
                text: "Evrak Tipi",
                value: "evrakTipi",
                sortable: false
            },
            {
                text: "Tarih",
                value: "tarih",
                sortable: false,
                align: 'center',
            },
            {
                text: "Para Birimi",
                value: "para.ParaBirimi",
                sortable: false,
                align: 'center',
            },
            {
                text: "Tutar",
                value: "dovizTutar",
                sortable: false,
                align: 'right'
            },
            {
                text: "Kur",
                value: "para.kur",
                sortable: false,
                align: 'right'
            },
            {
                text: "",
                value: "",
                sortable: false
            }

            ],
            tahsilatlar: [],
        }


    },
    props: {
        odemeData: {
            type: Array,
            required: true,
        },
        carikod:{
            type:Object,
            required:true
        }
    },
    components: {
        tahsilatdialog,
        caricomp
    },
    methods: {
        OdemeDuzenle(val) {
            this.$refs.tahsilatdialog.open("update", 200, val).then(
                sonuc => {
                    if (sonuc == true) {
                    }
                });
        },
        getCurrentInfo(currentInfo){
        //this.kalemData.Rez.masrafMerkezi.kod = currentInfo.ExpenseCenter; 
      },
        OdemeEkle() {
            this.$refs.tahsilatdialog.open("tahsilat", 200, null).then(
                sonuc => {
                    if (sonuc == true) {
                    }
                });
        },
        handleUpdateOdemeData(newData) {
            this.tahsilatlar.push(newData);// Dialogdan gelen veriyi güncelle
            this.$emit("update-odeme-data", this.tahsilatlar)
        },
        OdemeSil(item) {
            this.tahsilatlar = this.tahsilatlar.filter(x => x.EvrakNo !== item.EvrakNo);
            this.$emit("update-odeme-data", this.tahsilatlar)
        }
    }
}
</script>